<template>
  <div class="disabled_switch">
    <span class="label" v-if="inTemplate">
      {{ active ? "Inactivar IVR para editar" : "Activar IVR" }}
    </span>

    <a-tooltip placement="bottom" :title="tooltip ?? (active ? 'Inactivar' : 'Activar')">
      <a-switch
        name="chatbot-switch"
        :checked="active"
        :loading="loadingSwitch"
        :disabled="disabled"
        @change="handleChangeStatus(bot.id)"
        size="small"
      />
    </a-tooltip>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, createVNode } from "vue";
import { Modal, message } from "ant-design-vue";
import { QuestionCircleOutlined } from "@ant-design/icons-vue";

import { botServices } from "@/app/ivr/bot/services/BotServices";
import { BotStatus } from "@/app/ivr/bot/utils/enums";
import { Bot } from "@/@types/ivr";
import { ResponseError } from "@/app/shared/utils/httpManager";

const props = defineProps<{
  bot: Bot;
  inTemplate?: boolean;
  disabled?: boolean;
  tooltip?: string | null;
}>();

const emit = defineEmits<{
  (e: "update"): void;
}>();

const loadingSwitch = ref(false);
const active = computed(() => props.bot.status === BotStatus.Active);

const handleUpdate = () => emit("update");

const handleChangeStatus = async (id: number) => {
  // const botDetails = await botServices.getDetails(props.bot.id);

  // if (active.value && botDetails.total_tickets) {
  // actionModal.visible = true;
  // actionModal.total_tickets = chatbotDetails.total_tickets;
  // } else {
  try {
    loadingSwitch.value = true;

    const newStatus = active.value ? BotStatus.Inactive : BotStatus.Active;

    if (newStatus === BotStatus.Inactive) {
      await new Promise((res) => {
        Modal.confirm({
          centered: true,
          icon: createVNode(QuestionCircleOutlined),
          title: `¿Estás seguro de inactivar “${props.bot.name}”?`,
          content: "Recuerda que puedes volver a activar este chatbot cuando desees.",
          okText: "Inactivar",
          onOk: async () => {
            await botServices.changeStatus(id, newStatus);
            res(undefined);
          },
          onCancel: () => {
            loadingSwitch.value = false;
          },
        });
      });
    } else {
      await botServices.changeStatus(id, newStatus);
    }

    handleUpdate();
  } catch (error) {
    let errorMessage = "Ha ocurrido un error";

    if (error instanceof ResponseError) {
      console.error(error.data);
      errorMessage = error.getErrorMessage();
    }

    message.error(errorMessage);
  } finally {
    loadingSwitch.value = false;
  }
};
</script>

<style lang="sass" scoped>
.label
  margin-right: 5px
  font-size: 12px
  color: $gray-8

.disabled_switch
  display: flex
  align-items: center

:deep(.ant-tooltip-disabled-compatible-wrapper)
  width: max-content !important
  text-align: center

// .floating
//   position: absolute
//   right: 0
//   top: 0
//   bottom: 0
//   margin: auto 0
//   display: flex
//   align-items: center
//   margin-right: 12px
</style>
